"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectMigrationService = void 0;
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var PrepareStyles_1 = __importDefault(require("./TCDCProjectConverter/PrepareStyles"));
var ConvertProject_1 = __importDefault(require("./TCDCProjectConverter/ConvertProject"));
var Utils_1 = require("@CommonFrontendBackend/BlockConsolidation/Utils");
var ProjectMigrationService = (function () {
    function ProjectMigrationService(usingFeature, invoke, brandStore, blockConsolidationMigration, environment) {
        var _this = this;
        this.usingFeature = usingFeature;
        this.invoke = invoke;
        this.brandStore = brandStore;
        this.blockConsolidationMigration = blockConsolidationMigration;
        this.environment = environment;
        this.log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.DEBUG) {
                console.log.apply(console, __spreadArray(["[ProjectMigrationService]"], __read(args), false));
            }
        };
        this.runProjectMigrations = function (project) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, FeatureFlag_1.isUsingTCDC)(this.usingFeature)) return [3, 2];
                        return [4, this.tcdcMigration(project)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.usingFeature(FeatureFlag_1.default.AllowBlockMigration)) return [3, 4];
                        return [4, this.runBlockConsolidationMigration(project)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2, project];
                }
            });
        }); };
        this.tcdcMigration = function (project) { return __awaiter(_this, void 0, void 0, function () {
            var prepareStylesForTCDC, convertProjectForTCDC;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Running TCDC migration");
                        if (!project.usingTCDC) return [3, 1];
                        prepareStylesForTCDC = this.invoke(PrepareStyles_1.default);
                        prepareStylesForTCDC(project, this.brandStore);
                        return [3, 3];
                    case 1:
                        convertProjectForTCDC = this.invoke(ConvertProject_1.default);
                        return [4, convertProjectForTCDC(project)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2, project];
                }
            });
        }); };
        this.runBlockConsolidationMigration = function (project) { return __awaiter(_this, void 0, Promise, function () {
            var migratedBlocks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Running block consolidation migration");
                        return [4, this.blockConsolidationMigration.bulkMigrateBlocks(project.blocks, Utils_1.MigrationType.Block)];
                    case 1:
                        migratedBlocks = _a.sent();
                        if (migratedBlocks.length > 0) {
                            this.replaceMigratedBlocksInProject(project, migratedBlocks);
                        }
                        return [2, project];
                }
            });
        }); };
        this.replaceMigratedBlocksInProject = function (project, migratedBlocks) {
            _this.log("Replacing ".concat(migratedBlocks.length, " migrated blocks on project"));
            migratedBlocks.forEach(function (block) {
                var index = project.blocks.findIndex(function (projectBlock) { return projectBlock._id === block._id; });
                if (index !== -1) {
                    project.blocks.splice(index, 1, block);
                }
                else {
                    console.error("Could not replace block ".concat(block._id, " in project"));
                }
            });
        };
        this.DEBUG = this.environment !== "production" ? true : false;
    }
    return ProjectMigrationService;
}());
exports.ProjectMigrationService = ProjectMigrationService;
